import { gql } from '@apollo/client';

export const INTEGRATIONS_OPTIONS_QUERY = 'IntegrationsOptions';

export const GET_INTEGRATIONS_OPTIONS = gql`
  query ${INTEGRATIONS_OPTIONS_QUERY}($ids: [uuid]){
    integrations(where: { id: { _nin: $ids }}) {
      id
      name
      playbooks {
        id
        revision
        pipelineVariables: pipeline_variables {
          id
          name
        }
      }
    }
  }
`;
